/*
  Zenimal video captions
  Adds English captions to site videos that contain speech, and turns on
  YouTube captions for embedded YouTube videos.
  Caption text lives in assets/video-captions.json, keyed by the 32 character
  Shopify video file id that appears in every video URL.
*/
(function () {
  'use strict';

  var CAPTIONS_URL = window.zenimalCaptionsUrl;
  var captions = null;
  var loading = null;

  function videoId(video) {
    var sources = [video.currentSrc, video.getAttribute('src')];
    video.querySelectorAll('source').forEach(function (s) { sources.push(s.getAttribute('src')); });
    for (var i = 0; i < sources.length; i++) {
      var m = sources[i] && sources[i].match(/[0-9a-f]{32}/);
      if (m) return m[0];
    }
    return null;
  }

  function loadCaptions() {
    if (captions) return Promise.resolve(captions);
    if (!loading) {
      loading = fetch(CAPTIONS_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (data) { captions = data || {}; return captions; })
        .catch(function () { captions = {}; return captions; });
    }
    return loading;
  }

  function syncMode(video, track) {
    // Show captions whenever the sound is on. When a video plays muted in the
    // background, nobody hears the speech, so the captions stay out of the way;
    // viewers with player controls can still turn them on with the CC button.
    if (!track.track) return;
    track.track.mode = (!video.muted || video.controls) ? 'showing' : 'hidden';
  }

  function attach(video) {
    if (video.dataset.captionsChecked) return;
    var id = videoId(video);
    if (!id) return;
    video.dataset.captionsChecked = 'true';
    loadCaptions().then(function (data) {
      var vtt = data[id];
      if (!vtt || video.querySelector('track[kind="captions"]')) return;
      var url = URL.createObjectURL(new Blob([vtt], { type: 'text/vtt' }));
      var track = document.createElement('track');
      track.kind = 'captions';
      track.label = 'English';
      track.srclang = 'en';
      track.src = url;
      track.default = true;
      video.appendChild(track);
      syncMode(video, track);
      track.addEventListener('load', function () { syncMode(video, track); });
      video.addEventListener('volumechange', function () { syncMode(video, track); });
    });
  }

  function fixYouTube(frame) {
    if (frame.dataset.captionsChecked) return;
    frame.dataset.captionsChecked = 'true';
    var src = frame.getAttribute('src') || '';
    if (!/youtube(-nocookie)?\.com\/embed\//.test(src)) return;
    if (!frame.getAttribute('title')) frame.setAttribute('title', 'Zenimal video');
    if (src.indexOf('cc_load_policy') === -1) {
      frame.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'cc_load_policy=1&cc_lang_pref=en');
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'VIDEO') attach(root);
    if (root.tagName === 'IFRAME') fixYouTube(root);
    root.querySelectorAll('video').forEach(attach);
    root.querySelectorAll('iframe').forEach(fixYouTube);
  }

  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
        if (m.type === 'attributes' && m.target.tagName === 'VIDEO') {
          delete m.target.dataset.captionsChecked;
          attach(m.target);
        }
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    // Videos whose source is set late (lazy loading) are picked up once they load.
    document.addEventListener('loadedmetadata', function (e) {
      if (e.target && e.target.tagName === 'VIDEO') { delete e.target.dataset.captionsChecked; attach(e.target); }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
